import React, { useContext, useEffect, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import profile from "../../../assets/images/profile/education/pic1.jpg";
import { ThemeContext } from "../../../context/ThemeContext";
import Logout from "./Logout";
import { useSession } from "../../../context/SessionContext";
import TenantChangeModal from "../../components/TenantChangeModal";
import { getPublicTenantDetails } from "../../../services/publicService";

const PublicHeader = ({ onNote }) => {
  const { id } = useParams();
  const { background, changeBackground } = useContext(ThemeContext);
  const userSession = useSession();
  const [showTenantChangeModal, setShowTenantChangeModal] = useState(false);
  const [tenantData, setTenantData] = useState([]);

  const handleThemeMode = () => {
    if (background.value === "dark") {
      changeBackground({ value: "light", label: "Light" });
    } else {
      changeBackground({ value: "dark", label: "Dark" });
    }
  };

  async function fecthTenant(id) {
    const res = await getPublicTenantDetails(id);
    if (res) {
      setTenantData(res);
    }
  }

  useEffect(() => {
    if (id) {
      fecthTenant(id);
    }
  }, [id]);

  return (
    <>
      <style>{`
        .public-header-content {
          padding-left: 15px;
          padding-right: 15px;
          height: 100%;
          display: flex;
          align-items: center;
        }
        @media only screen and (max-width: 767px) {
          .public-header-content {
            padding-left: 5.5rem !important;
            padding-right: 12px;
          }
        }
      `}</style>
      <div className="header">
        <div className="header-content public-header-content">
          <nav className="navbar navbar-expand h-100">
            <div className="collapse navbar-collapse d-flex align-items-center">
              {tenantData?.name && (
                <span
                  className="text-truncate"
                  title={tenantData?.name}
                  style={{
                    fontSize: "clamp(12px, 3.8vw, 17px)",
                    fontWeight: "700",
                    color: "var(--text-dark, #1e1b4b)",
                    letterSpacing: "0.5px",
                    fontFamily: "'Inter', 'Segoe UI', sans-serif",
                    lineHeight: 1.2,
                    maxWidth: "100%",
                  }}
                >
                  {tenantData?.name}
                </span>
              )}
            </div>
          </nav>
        </div>
      </div>
      <TenantChangeModal
        show={showTenantChangeModal}
        onClose={() => setShowTenantChangeModal(false)}
      />
    </>
  );
};

export default PublicHeader;
